const {ccclass, property} = cc._decorator;

@ccclass
export default class alchemyAni extends cc.Component {

    @property({type:cc.Node,displayName:"修仙角色图片"})
    alchemyRole:cc.Node = null;

    @property({type:cc.Node,displayName:"修仙阴影图片"})
    alchemyShadow:cc.Node = null;

    onLoad(){
        let roleTween = cc.tween(this.alchemyRole).to(1.5,{y:70}).delay(0.1).to(1.5,{y:50}).delay(0.1);
        cc.tween(this.alchemyRole).repeatForever(roleTween).start();

        let shadowTween = cc.tween(this.alchemyShadow).to(1.5,{scale:0.8}).delay(0.1).to(1.5,{scale:1}).delay(0.1);
        cc.tween(this.alchemyShadow).repeatForever(shadowTween).start();

    }
    
}
